import React, { useState } from 'react';
import Adminheader from './Adminheader';
import "../Admin/assete/css/addcareersdetails.css";
import {CareerDetailsApi} from "../service/Api";
import Sidebar from './Siderbar';

const Addcareers = () => {

    const [formData, setFormData] = useState({
        job_name: '',
        Education: '',
        Experience: '',
        Location: '',
        Job_date:'',
        Job_Description: '',
      });
      const [errorMessage, setErrorMessage] = useState('');
      const [successMessage, setSuccessMessage] = useState('');
    
      const handleChange = (e) => {
        const { id, value } = e.target;
      
      if (id === "job_name") {
        const onlyLetters = /^[A-Za-z\s]+$/;
        if (!onlyLetters.test(value)) {
          setFormData({ ...formData, [id]: '' }); 
          return;
        } 
      }
      setFormData({ ...formData, [id]: value });
  };
    
      const handleSubmit = async () => {
        if (
            formData.job_name.trim() === '' ||
            formData.Education.trim() === '' ||
            formData.Experience.trim() === '' ||
            formData.Location.trim() === '' ||
            formData.Job_date.trim() === '' ||
            formData.Job_Description.trim() === ''
          ) {
            
      return;
    }
    try {
      // ✅ Format the Job_date
      const formattedDate = new Date(formData.Job_date).toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      }).replace(/ /g, '-');

      const formattedData = {
        ...formData,
        Job_date: formattedDate,
      };
    
                    
                    console.log("data ",formattedData );
                 const response = await CareerDetailsApi(formattedData);
                 console.log('Form data saved:', response.data);
                 setSuccessMessage(' submitted successfully!');
                 setFormData({
                    job_name: '',
                    Education: '',
                    Experience: '',
                    Location: '',
                    Job_date: '',
                    Job_Description: ''
                 });
                 setTimeout(() => {
                    setSuccessMessage('');
                  }, 2000);
                } catch (error) {
                    console.error('Error submitting form:', error);
                    setErrorMessage('Failed to submit career details.');
                  }
      };
    

      

  return (
   <>
      <div className='body-div'>
   <Adminheader/>
   <div className='container_dashboard'>
   <div className='index-content'>
    <Sidebar/>
    <div className='dashboard_main_div '>
   
    <div className='dashboard_div_3'>
    <div className='ad_career_form_div'> 
    <div className='ad_career_form_div_1' >
    <div className='ad_careers_main_div_1'>
      <h2>Add careers details</h2>
      </div>
        <h2>Job Name</h2>
        <input type='text' id="job_name" placeholder='Enter your Job Name' value={formData.job_name} onChange={handleChange} />       
        <h2>Education/Qualification</h2>
        <input type='text' id="Education" placeholder='Enter your Education' value={formData.Education} onChange={handleChange}/>
        <h2>Experience</h2>
        <input type='text' id="Experience" placeholder='Enter your Experience' value={formData.Experience} onChange={handleChange} />
        <h2>Location</h2>
        <input type='text' id="Location" placeholder='Enter your Location' value={formData.Location} onChange={handleChange}/>
         <h2>Job opening date</h2>
         <input type='date' id="Job_date" placeholder='Enter your opening date' value={formData.Job_date} onChange={handleChange} />
        <h2>Job Description</h2>
        <textarea type='text' id="Job_Description" placeholder='Enter your Job Description' value={formData.Job_Description} onChange={handleChange}/>
        <div className='career_add_button'>
            <button onClick={handleSubmit}>submit</button>
        </div>
        {errorMessage && <p className="error">{errorMessage}</p>}
          {successMessage && <p className="success">{successMessage}</p>}
        </div>
    </div>

</div>
      </div>
   </div>
   </div>
   </div>

   
   </>
  )
}

export default Addcareers